/**
 * Row layout for journey/library cards.
 *
 * Modes:
 *  - default: horizontal carousel (scroll-row), each card keeps its fixed flex width
 *  - columns (1-6): CSS grid that wraps to next line when there are more items
 */
export default function Row({ title, eyebrow, children, testId, columns }) {
    const colsMap = {
        1: "grid-cols-1",
        2: "grid-cols-1 sm:grid-cols-2",
        3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
        4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
        5: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5",
        6: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6",
    };
    const isGrid = typeof columns === "number" && columns >= 1 && columns <= 6;
    const gridCls = colsMap[columns] || colsMap[4];

    return (
        <section data-testid={testId} className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16">
            <div className="flex items-end justify-between mb-6">
                <div>
                    {eyebrow && <div className="overline text-[#5C5C5C]">{eyebrow}</div>}
                    <h2 className="font-display text-3xl md:text-4xl mt-1 tracking-tight">{title}</h2>
                </div>
            </div>
            {isGrid ? (
                <div data-testid={testId ? `${testId}-grid` : undefined} className={`grid ${gridCls} gap-6 grid-cards`}>
                    {children}
                </div>
            ) : (
                <div className="scroll-row no-scrollbar -mx-2 px-2">
                    {children}
                </div>
            )}
        </section>
    );
}
